import { API_ENDPOINTS } from '../utils/api-endpoints';
import useQueryWrapper, { queryOptions } from '../utils/use-query-wrapper';

const getShipment = ({ id }, options?: queryOptions) =>
  useQueryWrapper(API_ENDPOINTS.GET_SHIPMENT(id), options);

export default getShipment;
